import { Component, OnDestroy, OnInit } from '@angular/core';
import { forkJoin, Subscription } from 'rxjs';
import { LayoutService, NavbarBtn } from 'src/app/layout/layout.service';
import { ThirdPartyService } from '../../third-party.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-servicenear-sellers-details',
  templateUrl: './servicenear-sellers-details.component.html',
  styleUrls: ['./servicenear-sellers-details.component.scss']
})
export class ServicenearSellersDetailsComponent implements OnInit , OnDestroy{

  subscription = new Subscription();
  page: number = 1;
  loading: boolean = false;
  summaryLoading: boolean = false;
  sellerDetails: any = {};
  usageInvoices: any[] = [];
  branchID: number = 0;
  salesPOSSettings: any = {};
  sellerInfo: any = {};
  whatsAppForm: FormGroup;
  amountForm: FormGroup;
  adminDetails: any;
  bills: any[] = [];
  currentPlanInfo: any = null;
  Uuid: string = '';

  // --- Confirm modal state & helpers ---
  public confirmVisible: boolean = false;
  public confirmMessage: string = '';
  public confirmTitle: string = '';
  public confirmConfirmLabel: string = 'Confirm';
  public confirmCancelLabel: string = 'Cancel';
  public confirmAmount: boolean = false;
  private confirmCallback?: () => void;

  // for tost msg
  notificationMsg = '';
  showToast: boolean = false;
  isSuccess: boolean;

  constructor(
    public layoutService: LayoutService,
    private thirdPartyService: ThirdPartyService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    public configService: ConfigService,
  ) { }

  get whatsAppEntries(): FormArray {
    return this.whatsAppForm.get('entries') as FormArray;
  }

  ngOnInit(): void {
    this.populateToolbarData();
    this.setAllForms();
    this.branchID = Number(this.route.snapshot.paramMap.get('branchID'));
    this.subscription.add(this.thirdPartyService.getSelectedSeller().subscribe(seller => {
      if (seller) {
        this.sellerInfo = seller;
      }else{
        this.setSellerInfo();
      }
    }));
    this.getSellerDetails();
    this.getUsageInvoicesByBranch();
    this.adminDetails = this.thirdPartyService.getLoginDetails();
    
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private populateToolbarData() {
    this.layoutService.setToolbar({
      title: 'Customer Bills',
      isBack: true,
    });
    this.layoutService.setNavbarButtons([]);
  }

  private getSellerDetails() {
    this.summaryLoading = true;
    let params = {
      SecurityKey: 'serv$2015',
      BranchID: this.branchID
    }
    this.thirdPartyService.getBranchStatus(params).subscribe({
      next: (res: any) => {
        this.sellerDetails = res.ResponseData;
        this.salesPOSSettings = JSON.parse(this.sellerDetails.SalesPOSSettings || '{}');
        this.Uuid = this.salesPOSSettings?.SellerUnique;
        this.getCurrentPlanDetails();
        this.loadBills();
        this.summaryLoading = false;
      },
      error: (err: any) => {
        this.summaryLoading = false;
      }
    });
  }

  private getUsageInvoicesByBranch() {
    this.loading = true;
    let params = {
      securityKey: 'serv$2015',
      branchID: this.branchID
    }
    this.thirdPartyService.getUsageInvoicesByBranch(params).subscribe({
      next: (res: any) => {
        this.usageInvoices = (res.ResponseData || []).map((it: any) => ({ ...it, _showFullMessage: false }));
        // ensure form array matches invoices
        this.setWhatsAppFormArray();
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
      }
    });
  }

  private setAllForms(){
    this.whatsAppForm = this.fb.group({
      entries: this.fb.array([])
    });
    this.amountForm = this.fb.group({
      amount: [0]
    })
  }

  private setWhatsAppFormArray() {
    // clear existing
    const arr = this.whatsAppEntries;
    while (arr.length) arr.removeAt(0);

    this.usageInvoices.forEach((it: any) => {
      const phone = it?.BranchContact || it?.Contact || this.sellerInfo?.BranchContact || '';
      arr.push(this.fb.group({
        phoneNo: [phone, [Validators.required]]
      }));
    });
  }

  private notify(status: boolean, msg: string) {
    this.showToast = true;
    this.isSuccess = status;
    this.notificationMsg = msg;
    setTimeout(() => {
      this.showToast = false;
    }, 2000);
  }

  private loadBills() {
    forkJoin({
      history: this.configService.getSubscriptionBillsHistoryBySellerUuid({uuid: this.Uuid}),
      pending: this.configService.getPendingPaymentBySellerUuid({uuid: this.Uuid})
    }).subscribe(({ history, pending }: any) => {
      const historyArr = history.ResponseData || [];
      const pendingArr = pending.ResponseData || [];

      const historyWithFlag = historyArr.map(item => ({
        ...item,
        isPendingBill: false  
      }));

      const pendingWithFlag = pendingArr.map(item => ({
        ...item,
        isPendingBill: true
      }));

      this.bills = [...pendingWithFlag, ...historyWithFlag];
    });
  }

  private setSellerInfo(){
    let params = {
      BranchType: 'All'
    }
    this.thirdPartyService.getBranchWorkCountDetails(params).subscribe({
      next: (res: any) => {
        const branches = res.ResponseData;
        const sllr = branches.filter((b: any)=> b.BranchID == this.branchID)
        this.sellerInfo = sllr[0];
      },
      error: (err: any) => {
      }
    });
  }

  private getCurrentPlanDetails() {

    this.configService.getCurrentPlanBySellerUuid({uuid: this.Uuid}).subscribe((res: any) => {
      if(res?.Result === "Success"){
        const subscriptiondetails = res.ResponseData;
        const currentPlanDetails = subscriptiondetails?.Subscriptions;
        if(currentPlanDetails && currentPlanDetails[0]?.SubscriptionPlanHeader){
          this.currentPlanInfo = currentPlanDetails[0]?.SubscriptionPlanHeader;
        }
      }
      
    })
  }

  public sendWhatsApp(index: number, item?: any) {
    const control = this.whatsAppEntries.at(index);
    if (!control) return console.warn('No form control for index', index);
    const phoneRaw = control.get('phoneNo')?.value || '';
    const digits = (phoneRaw || '').toString().replace(/\D/g, '');
    if (!digits) return alert('Phone number is empty');

    const phoneForWA = digits.length === 10 ? '91' + digits : digits;
    const msg = item?.BillMessage || '';
    const url = `https://wa.me/${phoneForWA}?text=${encodeURIComponent(msg)}`;
    window.open(url, '_blank');
  }

  public onPayBill() {
    const amount = this.amountForm.get('amount')?.value;
    let params = {
      securityKey: 'serv$2015',
      branchId: this.branchID,
      invoiceDate: '',
      amount: String(amount)
    }
    this.thirdPartyService.updatePaymentStatus(params).subscribe({
      next: (res: any) => {
        if(res && res?.Result == "Success" && res?.ResponseData == "Success"){
          this.notify(true, 'Payment updated successfully');
          this.getSellerDetails();
        }else{
          this.notify(false, 'Payment updation failed');
        }
        this.confirmCancel();
      },
      error: (err: any) => {
        this.notify(false, 'Payment updation failed');
      }
    });

  }

  public onUpdateCredit() {
    const amount = this.amountForm.get('amount')?.value;
    let params = {
      securityKey: 'serv$2015',
      branchId: this.branchID,
      monthlyCreditLimit: String(amount)
    }
    this.thirdPartyService.updateMonthlyCreditLimit(params).subscribe({
      next: (res: any) => {
        if(res && res?.Result == "Success" && res?.ResponseData == "Success"){
          this.notify(true, 'Monthly credit limit updated successfully');
          this.getSellerDetails();
        }else{
          this.notify(false, 'Monthly credit limit updation failed');
        }
        this.confirmCancel();
      },
      error: (err: any) => {
        this.notify(false, 'Monthly credit limit updation failed');
      }
    });
  }

  public onMigrateSeller() {
    const params = {
      branchId: this.branchID
    }
    this.thirdPartyService.migrateServicenearBranchToV2(params).subscribe({
      next: (res: any) => {
        if(res && res?.Result == "Success" && res?.ResponseData == "Success"){
          this.notify(true, 'Branch migrated successfully');
          this.getSellerDetails();
        }else{
          this.notify(false, 'Branch migration failed');
        }
        this.confirmCancel();
      },
      error: (err: any) => {
        this.notify(false, 'Branch migration failed');
      }
    });
  }

  public toggleBanner() {
    let params = {
      securityKey: 'serv$2015',
      branchId: this.branchID
    }
    this.thirdPartyService.changePaymentBannerStatus(params).subscribe({
      next: (res: any) => {
        if(res && res?.Result == "Success"){
          if(res?.ResponseData == "enabled"){
            this.notify(true, 'Payment banner enabled successfully');
          }else if(res?.ResponseData == "disabled"){
            this.notify(true, 'Payment banner disabled successfully');
          }
          this.getSellerDetails();
        }else{
          this.notify(false, 'Payment banner updation failed');
        }
        this.confirmCancel();
      },
      error: (err: any) => {
        this.notify(false, 'Payment banner updation failed');
      }
    });
  }

  public toggleWhatsapp() {
    let params = {
      securityKey: 'serv$2015',
      branchId: this.branchID,
      statusType: "Whatsapp"
    }
    this.thirdPartyService.updateDifferentStatusesByType(params).subscribe({
      next: (res: any) => {
        if(res && res?.Result == "Success"){
          if(res?.ResponseData == "enabled"){
            this.notify(true, 'Whatsapp enabled successfully');
          }else if(res?.ResponseData == "disabled"){
            this.notify(true, 'Whatsapp disabled successfully');
          }
          this.getSellerDetails();
        }else{
          this.notify(false, 'Whatsapp updation failed');
        }
        this.confirmCancel();
      },
      error: (err: any) => {
        this.notify(false, 'Whatsapp updation failed');
      }
    });
  }

  public toggleCoreUser() {
    let params = {
      securityKey: 'serv$2015',
      branchId: this.branchID,
      statusType: "CoreUser"
    }
    this.thirdPartyService.updateDifferentStatusesByType(params).subscribe({
      next: (res: any) => {
        if(res && res?.Result == "Success"){
          if(res?.ResponseData == "enabled"){
            this.notify(true, 'Core user enabled successfully');
          }else if(res?.ResponseData == "disabled"){
            this.notify(true, 'Core user disabled successfully');
          }
          this.getSellerDetails();
        }else{
          this.notify(false, 'Core user updation failed');
        }
        this.confirmCancel();
      },
      error: (err: any) => {
        this.notify(false, 'Core user updation failed');
      }
    });
  }

  public changePage(page: number) {
    this.page = page;
  }

  public toggleMessage(item: any, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    item._showFullMessage = !item._showFullMessage;
  }

  public isLongMessage(msg?: string): boolean {
    return !!msg && msg.length > 120;
  }

  public formatUnixToReadable(unixTimestamp: number): string {
    if (!unixTimestamp) return '';

    return moment.unix(unixTimestamp).format('DD MMM YY, hh:mm a');
  }

  public copyContactNumber() {
    const number = this.sellerInfo?.BranchContact;

    if (!number) return;

    navigator.clipboard.writeText(number).then(() => {
      this.notify(true, 'Contact number copied to clipboard');
    });
  }

  public callThisNumber(){
    const phone = this.sellerInfo?.BranchContact;
    if (!phone) return;

    window.open(`tel:${phone}`, '_self');
  }

  public whatsAppThisNumber() {
    const phone = this.sellerInfo?.BranchContact;
    if (!phone) return;

    // Remove spaces or special chars
    const formatted = phone.replace(/[^0-9]/g, '');
    const whatsappNum = '91' + formatted;

    // WhatsApp API link
    const url = `https://wa.me/${whatsappNum}`;
    window.open(url, '_blank');
  }

  public showConfirm(message: string, callback: () => void, confirmtitle?: string, amountReq?: boolean, confirmLabel?: string, cancelLabel?: string) {
    this.confirmMessage = message;
    this.confirmCallback = callback;
    this.confirmTitle = confirmtitle || 'Confirm Action';
    this.confirmConfirmLabel = confirmLabel || 'Confirm';
    this.confirmCancelLabel = cancelLabel || 'Cancel';
    this.confirmAmount = amountReq;
    this.confirmVisible = true;
  }

  public confirmCancel() {
    this.confirmVisible = false;
    this.confirmCallback = undefined;
  }

  public confirmOK() {
    if (this.confirmCallback) {
      try {
        this.confirmCallback();
      } catch (e) {
        console.error('Error executing confirm callback', e);
      }
    }
    this.confirmCancel();
  }

  // convenience wrappers for actions on Page 1
  public confirmPayBill() {
    this.amountForm.reset();
    const aboutSeller = `${this.sellerInfo?.BranchName}(${this.sellerInfo.Place}) - ${this.sellerInfo.BranchContact}`
    this.showConfirm(`To pay: ${this.sellerDetails.PendingBillAmount}`, () => this.onPayBill(), aboutSeller, true,"Save Payment");
  }

  public confirmUpdateCredit() {
    this.amountForm.reset();
    const aboutSeller = `${this.sellerInfo?.BranchName}(${this.sellerInfo.Place}) - ${this.sellerInfo.BranchContact}`
    this.showConfirm(`Current credit limit : ${this.sellerDetails.MonthlyCredit}`, () => this.onUpdateCredit(), aboutSeller, true, "Change Credit Limit");
  }

  public confirmToggleBanner() {
    const action = this.sellerDetails.EnablePaymentBanner ? 'Disable' : 'Enable';
    this.showConfirm(`${action} payment banner?`, () => this.toggleBanner());
  }

  public confirmToggleWhatsapp() {
    const action = this.sellerDetails.WhatsappEnabled ? 'Disable' : 'Enable';
    this.showConfirm(`${action} Whatsapp for this seller?`, () => this.toggleWhatsapp());
  }

  public confirmToggleCoreUser() {
    const action = this.sellerDetails.CoreUser ? 'Revoke' : 'Make';
    this.showConfirm(`${action} core user status?`, () => this.toggleCoreUser());
  }

  public confirmMigrateSeller() {
    this.showConfirm('Confirm migrate seller?', () => this.onMigrateSeller(),"Migrate Seller", false, "Migrate","");
  }

}  
